import { makeAutoObservable } from 'mobx';
import { TPaginationState } from '@features/categories/typescript';
import { PRODUCTS_RENDER_COUNTS } from '@features/categories/const';
import { getListingPageFromQuery, LISTING_PAGE_QUERY, setListingPageInUrl } from '@utils/listingPaginationUrl';
class PaginationState {
  public count = 0;
  public offset = 0;
  public productsToRender = PRODUCTS_RENDER_COUNTS;
  private $page = 1;
  private queryName = LISTING_PAGE_QUERY;
  constructor(pagination: TPaginationState) {
    makeAutoObservable(this);
    this.productsToRender = 0;
    this.count = pagination.count;
    this.offset = pagination.offset;
    const maxPage = Math.ceil(pagination.count / PRODUCTS_RENDER_COUNTS) || 1;
    const page = Math.ceil(pagination.productsToRender / PRODUCTS_RENDER_COUNTS) || 1;
    this.$page = page > maxPage ? maxPage : Math.ceil(page);
  }
  public resetPagination = () => {
    this.productsToRender = PRODUCTS_RENDER_COUNTS;
    this.$page = 1;
    this.offset = 0;
    this.count = 0;
  };

  /** Reset to page 1 without clearing count (avoids listing layout collapse / scroll jump while refetching). */
  public resetToFirstPage = () => {
    this.offset = 0;
    this.$page = 1;
  };
  public get page() {
    return this.$page;
  }
  public set page(value: number) {
    const maxPage = Math.ceil(this.count / PRODUCTS_RENDER_COUNTS);
    this.$page = value > maxPage ? maxPage : Math.ceil(value);
  }
  public setProductsToRender = (value: number, page?: number) => {
    this.productsToRender = value;
    this.page = page ? page : Math.ceil((this.offset + this.productsToRender) / PRODUCTS_RENDER_COUNTS);
  };
  public setCount = (value: number) => {
    this.count = value;
  };
  public setOffset = (value: number) => {
    this.offset = value;
  };
  public setPageToURLString = () => {
    setListingPageInUrl(this.page);
  };
  public getPageFromURLString = () => {
    const page = getListingPageFromQuery(typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get(this.queryName) || undefined : undefined);
    // Preserve the current productsToRender value instead of resetting it to PRODUCTS_RENDER_COUNTS
    // Only update offset based on the page number
    this.setOffset((page - 1) * PRODUCTS_RENDER_COUNTS);
    return page;
  };
}
export default PaginationState;